import React from 'react';
import Icon from '../lib/Icon';

/** Slim confidentiality bar atop a coach-only individual view. */
export default function ConfidentialBanner() {
  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 11, padding: '11px 16px',
      borderRadius: 'var(--radius-md)', background: 'var(--human-50)', border: '1px solid var(--human-100)',
    }}>
      <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: 'var(--human-600)', flex: 'none' }}>
        <Icon name="lock" size={15} />
      </span>
      <span style={{ fontFamily: 'var(--font-sans)', fontWeight: 'var(--w-bold)', fontSize: 'var(--text-sm)', letterSpacing: 'var(--track-tight)', color: 'var(--human-700)' }}>
        Private · Independent coach view
      </span>
      <span style={{ fontSize: 'var(--text-sm)', color: 'var(--human-600)' }}>
        Individual results stay with the coach — that's what keeps the feedback candid.
      </span>
    </div>
  );
}
